<app-navbar-style-one></app-navbar-style-one>

<!-- <div class="slider-area owl-carousel owl-theme">
    <div class="slider-item item-bg1">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Explore Places In Suburb <b>Keep Choose Best</b></h1>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="slider-item item-bg2">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Find Best The Restaurants <b>In Your Choose</b></h1>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="slider-item item-bg3">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Discover The Exact Event <b>In Your Choose</b></h1>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="slider-item item-bg4">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Find The Amazing Hotel <b>Keep Your Choose</b></h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->


<div class="slider-area owl-carousel owl-theme">
    <div class="slider-item item-bg1">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Encuentra <b>Los Mejores Abogados</b> Cerca de Ti</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="slider-item item-bg2">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Asesorías <b>Para Cada Necesidad Empresarial</b></h1>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="slider-item item-bg3">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Gestorías Que <b>Facilitan Tu Vida Administrativa</b></h1>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="slider-item item-bg4">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Consultorías <b>Para Impulsar Tu Negocio</b></h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="banner-form-area banner-form-mt">
    <div class="container">
        <!-- <div class="form-list text-center">
            <ul>
                <li class="active"><i class="flaticon-curve-arrow"></i> PLACES</li>
                <li><i class="flaticon-curve-arrow"></i> RESTAURANTS</li>
                <li><i class="flaticon-curve-arrow"></i> EVENTS</li>
                <li><i class="flaticon-curve-arrow"></i> HOTELS</li>
            </ul>
        </div> -->

        <div class="form-list text-center">
            <ul>
                <li class="active"><i class="flaticon-curve-arrow"></i> ABOGADOS</li>
                <li><i class="flaticon-curve-arrow"></i> ASESORÍAS</li>
                <li><i class="flaticon-curve-arrow"></i> GESTORÍAS</li>
                <li><i class="flaticon-curve-arrow"></i> CONSULTORÍAS</li>
                <li><i class="flaticon-curve-arrow"></i> STARTUPS</li>
                <!-- <li><i class="flaticon-curve-arrow"></i> ESTRATEGIAS EMPRESARIALES</li> -->
            </ul>
        </div>

        <div class="banner-form border-radius">
            <form>
                <div class="row">
                    <div class="col-lg-2 col-md-4">
                        <div class="form-group">
                            <i class='flaticon-place'></i>
                            <input class="form-control" type="text" placeholder="Ubicación">
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-4">
                        <div class="form-group">
                            <i class='flaticon-vision'></i>
                            <input class="form-control" type="text" placeholder="¿Qué servicio buscas?">
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-4">
                        <div class="form-group">
                            <i class='flaticon-category'></i>
                            <select class="form-control">
                                <option>Todas las Categorías</option>
                                <option>Abogados</option>
                                <option>Asesorías</option>
                                <option>Gestorías</option>
                                <option>Consultorías</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-lg-2 col-sm-6 offset-sm-3 offset-lg-0">
                        <button type="submit" class="default-btn border-radius">Buscar <i class="flaticon-loupe"></i></button>
                    </div>
                </div>
            </form>
        </div>

    </div>
</div>

<!-- <section class="category-area pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span>The Categories</span>
            <h2>Use Quick Search By Category</h2>
        </div>

        <div class="row category-bg">
            <div class="col-lg-4 col-sm-6">
                <div class="category-card">
                    <a routerLink="/category"><i class="flaticon-bake"></i></a>
                    <a routerLink="/category"><h3>Restaurant</h3></a>
                    <p>Lorem ipsum dolor sit amet consecte tempo quaerat voluptatem.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="category-card">
                    <a routerLink="/category"><i class="flaticon-hotel"></i></a>
                    <a routerLink="/category"><h3>Hotel & Resort</h3></a>
                    <p>Lorem ipsum dolor sit amet consecte tempo quaerat voluptatem.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="category-card">
                    <a routerLink="/category"><i class="flaticon-barbell"></i></a>
                    <a routerLink="/category"><h3>Fitness Club</h3></a>
                    <p>Lorem ipsum dolor sit amet consecte tempo quaerat voluptatem.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="category-card">
                    <a routerLink="/category"><i class="flaticon-store"></i></a>
                    <a routerLink="/category"><h3>Shops & Stores</h3></a>
                    <p>Lorem ipsum dolor sit amet consecte tempo quaerat voluptatem.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="category-card">
                    <a routerLink="/category"><i class="flaticon-event"></i></a>
                    <a routerLink="/category"><h3>Events & Programme</h3></a>
                    <p>Lorem ipsum dolor sit amet consecte tempo quaerat voluptatem.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="category-card">
                    <a routerLink="/category"><i class="flaticon-flower"></i></a>
                    <a routerLink="/category"><h3>Beauty & Spa</h3></a>
                    <p>Lorem ipsum dolor sit amet consecte tempo quaerat voluptatem.</p>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="category-area pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span>Áreas de Especialidad</span>
            <h2>Búsqueda Rápida por Categoría</h2>
        </div>

        <div class="row category-bg">
            <div class="col-lg-4 col-sm-6">
                <div class="category-card">
                    <a routerLink="/category"><i class="flaticon-event"></i></a>
                    <a routerLink="/category"><h3>Abogados</h3></a>
                    <p>Expertos legales listos para asesorarte y representarte en diversas áreas.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="category-card">
                    <a routerLink="/category"><i class="flaticon-event"></i></a>
                    <a routerLink="/category"><h3>Asesorías</h3></a>
                    <p>Profesionales en finanzas, contabilidad, fiscales y laborales al alcance de un clic.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="category-card">
                    <a routerLink="/category"><i class="flaticon-event"></i></a>
                    <a routerLink="/category"><h3>Gestorías</h3></a>
                    <p>Servicios administrativos y vehiculares de la mano de expertos.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="category-card">
                    <a routerLink="/category"><i class="flaticon-event"></i></a>
                    <a routerLink="/category"><h3>Consultorías</h3></a>
                    <p>Asesoramiento empresarial, tecnológico y estratégico para potenciar tu negocio.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="category-card">
                    <a routerLink="/category"><i class="flaticon-event"></i></a>
                    <a routerLink="/category"><h3>Servicios para Startups</h3></a>
                    <p>Desde la estructuración legal inicial hasta la consultoría de crecimiento. ¡Todo para que tu startup despegue!</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="category-card">
                    <a routerLink="/category"><i class="flaticon-event"></i></a>
                    <a routerLink="/category"><h3>Gestión de Documentación</h3></a>
                    <p>Desde contratos, licencias, permisos hasta papeleo administrativo. ¡Deja que nuestros expertos gestionen tus documentos!</p>
                </div>
            </div>

        </div>
    </div>
</section>


<section class="place-list-area pb-70">
    <div class="container-fluid">
        <div class="section-title text-center">
            <span>Listado de Profesionales</span>
            <h2>Los últimos profesionales registrados</h2>
            <p>Conecta con expertos en diferentes áreas y resuelve tus necesidades con confianza y eficacia.</p>
        </div>


        <div class="place-slider owl-carousel owl-theme pt-45">
            <div class="place-list-item">
                <div class="images">
                    <a routerLink="/professional-details" class="images-list"><img src="assets/img/place-list/place-list1.png" alt="Foto Profesional"></a>

                    <div class="place-profile">
                        <img src="assets/img/place-list/place-profile.png" alt="Foto perfil">
                        <h3>Por, José Martínez</h3>
                    </div>

                    <div class="place-status bg-dark-orange">
                        <a routerLink="/professional-details"><h3>Disponible ahora</h3></a>
                    </div>

                    <div class="place-tag">
                        <ul>
                            <li><a routerLink="/"><i class="flaticon-place"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                        </ul>
                        <span><a routerLink="/">$$$</a></span>
                        <h3 class="title"><a routerLink="/professional-details">Abogado</a></h3>
                    </div>
                </div>

                <div class="content">
                    <a routerLink="/professional-details"><h3>Despacho Legal Martínez</h3></a>
                    <p><i class="flaticon-cursor"></i> Avenida Libertad, 245, 28080 Madrid, España</p>
                    <ul class="place-rating">
                        <li><a routerLink="/">4.7</a></li>
                        <li>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star icon-color'></i>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="place-list-item">
                <div class="images">
                    <a routerLink="/professional-details" class="images-list"><img src="assets/img/place-list/place-list1.png" alt="Foto Profesional"></a>

                    <div class="place-profile">
                        <img src="assets/img/place-list/place-profile.png" alt="Foto perfil">
                        <h3>Por, José Martínez</h3>
                    </div>

                    <div class="place-status bg-color-blue">
                        <a routerLink="/professional-details"><h3>Disponible ahora</h3></a>
                    </div>

                    <div class="place-tag">
                        <ul>
                            <li><a routerLink="/"><i class="flaticon-place"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                        </ul>
                        <span><a routerLink="/">$$$</a></span>
                        <h3 class="title"><a routerLink="/professional-details">Abogado</a></h3>
                    </div>
                </div>

                <div class="content">
                    <a routerLink="/professional-details"><h3>Despacho Legal Martínez</h3></a>
                    <p><i class="flaticon-cursor"></i> Avenida Libertad, 245, 28080 Madrid, España</p>
                    <ul class="place-rating">
                        <li><a routerLink="/">4.7</a></li>
                        <li>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star icon-color'></i>
                        </li>
                    </ul>
                </div>
            </div>


            <div class="place-list-item">
                <div class="images">
                    <a routerLink="/professional-details" class="images-list"><img src="assets/img/place-list/place-list1.png" alt="Foto Profesional"></a>

                    <div class="place-profile">
                        <img src="assets/img/place-list/place-profile.png" alt="Foto perfil">
                        <h3>Por, José Martínez</h3>
                    </div>

                    <div class="place-status bg-color-blue">
                        <a routerLink="/professional-details"><h3>Disponible ahora</h3></a>
                    </div>

                    <div class="place-tag">
                        <ul>
                            <li><a routerLink="/"><i class="flaticon-place"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                        </ul>
                        <span><a routerLink="/">$$$</a></span>
                        <h3 class="title"><a routerLink="/professional-details">Abogado</a></h3>
                    </div>
                </div>

                <div class="content">
                    <a routerLink="/professional-details"><h3>Despacho Legal Martínez</h3></a>
                    <p><i class="flaticon-cursor"></i> Avenida Libertad, 245, 28080 Madrid, España</p>
                    <ul class="place-rating">
                        <li><a routerLink="/">4.7</a></li>
                        <li>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star icon-color'></i>
                        </li>
                    </ul>
                </div>
            </div>


            <div class="place-list-item">
                <div class="images">
                    <a routerLink="/professional-details" class="images-list"><img src="assets/img/place-list/place-list1.png" alt="Foto Profesional"></a>

                    <div class="place-profile">
                        <img src="assets/img/place-list/place-profile.png" alt="Foto perfil">
                        <h3>Por, José Martínez</h3>
                    </div>

                    <div class="place-status bg-dark-orange">
                        <a routerLink="/professional-details"><h3>Disponible ahora</h3></a>
                    </div>

                    <div class="place-tag">
                        <ul>
                            <li><a routerLink="/"><i class="flaticon-place"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                        </ul>
                        <span><a routerLink="/">$$$</a></span>
                        <h3 class="title"><a routerLink="/professional-details">Abogado</a></h3>
                    </div>
                </div>

                <div class="content">
                    <a routerLink="/professional-details"><h3>Despacho Legal Martínez</h3></a>
                    <p><i class="flaticon-cursor"></i> Avenida Libertad, 245, 28080 Madrid, España</p>
                    <ul class="place-rating">
                        <li><a routerLink="/">4.7</a></li>
                        <li>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star icon-color'></i>
                        </li>
                    </ul>
                </div>
            </div>


            <div class="place-list-item">
                <div class="images">
                    <a routerLink="/professional-details" class="images-list"><img src="assets/img/place-list/place-list1.png" alt="Foto Profesional"></a>

                    <div class="place-profile">
                        <img src="assets/img/place-list/place-profile.png" alt="Foto perfil">
                        <h3>Por, José Martínez</h3>
                    </div>

                    <div class="place-status bg-color-blue">
                        <a routerLink="/professional-details"><h3>Disponible ahora</h3></a>
                    </div>

                    <div class="place-tag">
                        <ul>
                            <li><a routerLink="/"><i class="flaticon-place"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                        </ul>
                        <span><a routerLink="/">$$$</a></span>
                        <h3 class="title"><a routerLink="/professional-details">Abogado</a></h3>
                    </div>
                </div>

                <div class="content">
                    <a routerLink="/professional-details"><h3>Despacho Legal Martínez</h3></a>
                    <p><i class="flaticon-cursor"></i> Avenida Libertad, 245, 28080 Madrid, España</p>
                    <ul class="place-rating">
                        <li><a routerLink="/">4.7</a></li>
                        <li>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star icon-color'></i>
                        </li>
                    </ul>
                </div>
            </div>


            <div class="place-list-item">
                <div class="images">
                    <a routerLink="/professional-details" class="images-list"><img src="assets/img/place-list/place-list1.png" alt="Foto Profesional"></a>

                    <div class="place-profile">
                        <img src="assets/img/place-list/place-profile.png" alt="Foto perfil">
                        <h3>Por, José Martínez</h3>
                    </div>

                    <div class="place-status bg-color-blue">
                        <a routerLink="/professional-details"><h3>Disponible ahora</h3></a>
                    </div>

                    <div class="place-tag">
                        <ul>
                            <li><a routerLink="/"><i class="flaticon-place"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                        </ul>
                        <span><a routerLink="/">$$$</a></span>
                        <h3 class="title"><a routerLink="/professional-details">Abogado</a></h3>
                    </div>
                </div>

                <div class="content">
                    <a routerLink="/professional-details"><h3>Despacho Legal Martínez</h3></a>
                    <p><i class="flaticon-cursor"></i> Avenida Libertad, 245, 28080 Madrid, España</p>
                    <ul class="place-rating">
                        <li><a routerLink="/">4.7</a></li>
                        <li>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star'></i>
                            <i class='bx bxs-star icon-color'></i>
                        </li>
                    </ul>
                </div>
            </div>


        </div>
    </div>
</section>

<!-- <section class="process-area process-bg pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span>Process</span>
            <h2>See How It Works</h2>
            <p>Porem ipsum dolor sit ame consectetur adipisicing incididunt </p>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-sm-6">
                <div class="process-card">
                    <i class="flaticon-position icon-bg"></i>
                    <h3>Find Interesting Place</h3>
                    <p>Lorem ipsum dolor sit amet, consetetur adipisicing elit, sed do eiusmod tempor  quam voluptatem.</p>
                    <div class="process-number">1</div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="process-card">
                    <i class="flaticon-to-do-list icon-bg"></i>
                    <h3>Choose What To Do</h3>
                    <p>Lorem ipsum dolor sit amet, consetetur adipisicing elit, sed do eiusmod tempor  quam voluptatem.</p>
                    <div class="process-number active">2</div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 offset-sm-3 offset-lg-0">
                <div class="process-card">
                    <i class="flaticon-box icon-bg"></i>
                    <h3>Find What You Want</h3>
                    <p>Lorem ipsum dolor sit amet, consetetur adipisicing elit, sed do eiusmod tempor  quam voluptatem.</p>
                    <div class="process-number">3</div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="process-area process-bg pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span>Proceso</span>
            <h2>Vea Cómo Funciona</h2>
            <p>Descubra cómo AccioGest puede ayudarle a encontrar el profesional adecuado.</p>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-sm-6">
                <div class="process-card">
                    <i class="flaticon-position icon-bg"></i>
                    <h3>Identifique su Necesidad</h3>
                    <p>Sea claro con lo que necesita. Ya sea una consultoría legal, una asesoría fiscal o cualquier otro servicio.</p>
                    <div class="process-number">1</div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="process-card">
                    <i class="flaticon-to-do-list icon-bg"></i>
                    <h3>Elige el Profesional</h3>
                    <p>Explore los perfiles de los profesionales disponibles en AccioGest y elija el que mejor se adapte a sus requisitos.</p>
                    <div class="process-number active">2</div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 offset-sm-3 offset-lg-0">
                <div class="process-card">
                    <i class="flaticon-box icon-bg"></i>
                    <h3>Agende una Cita</h3>
                    <p>Una vez que haya encontrado al profesional adecuado, programe una cita para discutir sus necesidades en detalle.</p>
                    <div class="process-number">3</div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="city-area ptb-100">
    <div class="container">
        <div class="section-title text-center">
            <span>Regiones</span>
            <h2>Explore las Mejores Regiones</h2>
            <p>Descubra los principales centros profesionales y encuentre expertos en su área.</p>
        </div>

        <div class="row pt-45">
            <div class="col-lg-7 col-md-7">
                <div class="city-item">
                    <a routerLink="/" class="city-img"><img src="assets/img/city-area/city-area1.png" alt="Imagen"></a>
                    <div class="city-content">
                        <i class="flaticon-buildings"></i>
                        <div class="city-text">
                            <a routerLink="/"><h3>Madrid</h3></a>
                            <p>Centro financiero y legal del país, con una amplia variedad de expertos.</p>
                        </div>
                    </div>
                    <h3 class="city-location">35 Despachos</h3>
                </div>
            </div>

            <div class="col-lg-5 col-md-5">
                <div class="city-item">
                    <a routerLink="/" class="city-img"><img src="assets/img/city-area/city-area2.png" alt="Imagen"></a>
                    <div class="city-content">
                        <i class="flaticon-buildings"></i>
                        <div class="city-text">
                            <a routerLink="/"><h3>Barcelona</h3></a>
                            <p>Con un vibrante mercado de consultores y asesores.</p>
                        </div>
                    </div>
                    <h3 class="city-location">28 Despachos</h3>
                </div>
            </div>

            <div class="col-lg-5 col-md-5">
                <div class="city-item">
                    <a routerLink="/" class="city-img"><img src="assets/img/city-area/city-area3.png" alt="Imagen"></a>
                    <div class="city-content">
                        <i class="flaticon-buildings"></i>
                        <div class="city-text">
                            <a routerLink="/"><h3>Valencia</h3></a>
                            <p>Conozca expertos en áreas comerciales y fiscales.</p>
                        </div>
                    </div>
                    <h3 class="city-location">22 Despachos</h3>
                </div>
            </div>

            <div class="col-lg-7 col-md-7">
                <div class="city-item">
                    <a routerLink="/" class="city-img"><img src="assets/img/city-area/city-area4.png" alt="Imagen"></a>
                    <div class="city-content">
                        <i class="flaticon-buildings"></i>
                        <div class="city-text">
                            <a routerLink="/"><h3>Sevilla</h3></a>
                            <p>Una región en crecimiento con profesionales especializados.</p>
                        </div>
                    </div>
                    <h3 class="city-location">15 Despachos</h3>
                </div>
            </div>

            <div class="col-lg-12 text-center mt-3">
                <a routerLink="/" class="default-btn border-radius">Ver todos los despachos <i class='bx bx-plus'></i></a>
            </div>
        </div>
    </div>
</section>


<div class="video-area video-area-bg">
    <div class="container">
        <div class="video-content">
            <h2>¿Estás listo para potenciar tu negocio con AccioGest?</h2>
            <p>Descubre cómo nuestros servicios profesionales pueden marcar la diferencia.</p>
            <a href="https://www.youtube.com/watch?v=[URL_DEL_VIDEO]" class="play-btn"><i class='bx bx-play'></i></a>
        </div>
    </div>
</div>


<div class="counter-area">
    <div class="container">
        <div class="counter-bg">
            <div class="row">
                <div class="col-lg-3 col-sm-6 col-md-3">
                    <div class="single-counter">
                        <h3>750</h3>
                        <span>Nuevos clientes cada mes</span>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-3">
                    <div class="single-counter">
                        <h3>2000+</h3>
                        <span>Trámites gestionados diariamente</span>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-3">
                    <div class="single-counter">
                        <h3>15</h3>
                        <span>Reconocimientos en el sector</span>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-3">
                    <div class="single-counter">
                        <h3>500+</h3>
                        <span>Consultas resueltas cada semana</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="place-area pt-100 pb-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="section-title mb-45">
                    <span>Servicios Destacados</span>
                    <h2>Los más solicitados</h2>
                </div>
            </div>

            <div class="col-lg-5 col-md-6">
                <div class="service-btn">
                    <a routerLink="/servicios" class="default-btn border-radius">Ver todos los servicios <i class='bx bx-plus'></i></a>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="place-card">
                    <a routerLink="/listing-details" class="place-images"><img src="assets/img/place-area/asesor1.png" alt="Images"></a>

                    <div class="rating">
                        <ul>
                            <li><a routerLink="/">4.9</a></li>
                            <li>
                                <span>23 Opiniones</span>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star i-color'></i>
                                <i class='bx bxs-star i-color'></i>
                            </li>
                        </ul>
                    </div>

                    <div class="status-tag bg-dark-orange">
                        <a routerLink="/listing-details"><h3>Disponible Ahora</h3></a>
                    </div>

                    <div class="content">
                        <div class="content-profile">
                            <img src="assets/img/place-area/place-area-profile.png" alt="Images">
                            <h3>Por, Juan Pérez</h3>
                        </div>
                        <span><i class="flaticon-cursor"></i> Calle Luna 123, Madrid, España</span>
                        <a routerLink="/listing-details"><h3>Consultoría Fiscal </h3></a>
                        <p>Ofrecemos asesoramiento fiscal y contable para pymes y autónomos. Expertos en el sector con más de 10 años de experiencia.</p>
                        <div class="content-tag">
                            <ul>
                                <li><a routerLink="/"><i class="flaticon-place"></i></a></li>
                                <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                                <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                            </ul>
                            <h3 class="price"> <a href="#">200€-500€</a></h3>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="place-card">
                    <a routerLink="/listing-details" class="place-images"><img src="assets/img/place-area/asesor2.png" alt="Images"></a>

                    <div class="rating">
                        <ul>
                            <li><a routerLink="/">4.9</a></li>
                            <li>
                                <span>23 Opiniones</span>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star i-color'></i>
                                <i class='bx bxs-star i-color'></i>
                            </li>
                        </ul>
                    </div>

                    <div class="status-tag bg-color-blue">
                        <a routerLink="/listing-details"><h3>Disponible Ahora</h3></a>
                    </div>

                    <div class="content">
                        <div class="content-profile">
                            <img src="assets/img/place-area/place-area-profile.png" alt="Images">
                            <h3>Por, Marta Perez</h3>
                        </div>
                        <span><i class="flaticon-cursor"></i> Calle Luna 123, Madrid, España</span>
                        <a routerLink="/listing-details"><h3>Consultoría Fiscal </h3></a>
                        <p>Ofrecemos asesoramiento fiscal y contable para pymes y autónomos. Expertos en el sector con más de 10 años de experiencia.</p>
                        <div class="content-tag">
                            <ul>
                                <li><a routerLink="/"><i class="flaticon-place"></i></a></li>
                                <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                                <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                            </ul>
                            <h3 class="price"> <a href="#">200€-500€</a></h3>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6">
                <div class="place-card">
                    <a routerLink="/listing-details" class="place-images"><img src="assets/img/place-area/asesor1.png" alt="Images"></a>

                    <div class="rating">
                        <ul>
                            <li><a routerLink="/">4.9</a></li>
                            <li>
                                <span>23 Opiniones</span>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star i-color'></i>
                                <i class='bx bxs-star i-color'></i>
                            </li>
                        </ul>
                    </div>

                    <div class="status-tag bg-color-heliotrope">
                        <a routerLink="/listing-details"><h3>Disponible Ahora</h3></a>
                    </div>

                    <div class="content">
                        <div class="content-profile">
                            <img src="assets/img/place-area/place-area-profile.png" alt="Images">
                            <h3>Por, Juan Pérez</h3>
                        </div>
                        <span><i class="flaticon-cursor"></i> Calle Luna 123, Madrid, España</span>
                        <a routerLink="/listing-details"><h3>Consultoría Fiscal </h3></a>
                        <p>Ofrecemos asesoramiento fiscal y contable para pymes y autónomos. Expertos en el sector con más de 10 años de experiencia.</p>
                        <div class="content-tag">
                            <ul>
                                <li><a routerLink="/"><i class="flaticon-place"></i></a></li>
                                <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                                <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                            </ul>
                            <h3 class="price"> <a href="#">200€-500€</a></h3>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6">
                <div class="place-card">
                    <a routerLink="/listing-details" class="place-images"><img src="assets/img/place-area/asesor1.png" alt="Images"></a>

                    <div class="rating">
                        <ul>
                            <li><a routerLink="/">4.9</a></li>
                            <li>
                                <span>23 Opiniones</span>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star i-color'></i>
                                <i class='bx bxs-star i-color'></i>
                            </li>
                        </ul>
                    </div>

                    <div class="status-tag bg-dark-orange">
                        <a routerLink="/listing-details"><h3>Disponible Ahora</h3></a>
                    </div>

                    <div class="content">
                        <div class="content-profile">
                            <img src="assets/img/place-area/place-area-profile.png" alt="Images">
                            <h3>Por, Pedro Casado</h3>
                        </div>
                        <span><i class="flaticon-cursor"></i> Calle Luna 123, Madrid, España</span>
                        <a routerLink="/listing-details"><h3>Consultoría Fiscal </h3></a>
                        <p>Ofrecemos asesoramiento fiscal y contable para pymes y autónomos. Expertos en el sector con más de 10 años de experiencia.</p>
                        <div class="content-tag">
                            <ul>
                                <li><a routerLink="/"><i class="flaticon-place"></i></a></li>
                                <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                                <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                            </ul>
                            <h3 class="price"> <a href="#">200€-500€</a></h3>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6">
                <div class="place-card">
                    <a routerLink="/listing-details" class="place-images"><img src="assets/img/place-area/asesor2.png" alt="Images"></a>

                    <div class="rating">
                        <ul>
                            <li><a routerLink="/">4.9</a></li>
                            <li>
                                <span>23 Opiniones</span>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star i-color'></i>
                                <i class='bx bxs-star i-color'></i>
                            </li>
                        </ul>
                    </div>

                    <div class="status-tag bg-color-blue">
                        <a routerLink="/listing-details"><h3>Disponible Ahora</h3></a>
                    </div>

                    <div class="content">
                        <div class="content-profile">
                            <img src="assets/img/place-area/place-area-profile.png" alt="Images">
                            <h3>Por, Cristina Fernandez</h3>
                        </div>
                        <span><i class="flaticon-cursor"></i> Calle Luna 123, Madrid, España</span>
                        <a routerLink="/listing-details"><h3>Consultoría Fiscal </h3></a>
                        <p>Ofrecemos asesoramiento fiscal y contable para pymes y autónomos. Expertos en el sector con más de 10 años de experiencia.</p>
                        <div class="content-tag">
                            <ul>
                                <li><a routerLink="/"><i class="flaticon-place"></i></a></li>
                                <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                                <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                            </ul>
                            <h3 class="price"> <a href="#">200€-500€</a></h3>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="place-card">
                    <a routerLink="/listing-details" class="place-images"><img src="assets/img/place-area/asesor1.png" alt="Images"></a>

                    <div class="rating">
                        <ul>
                            <li><a routerLink="/">4.9</a></li>
                            <li>
                                <span>23 Opiniones</span>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star i-color'></i>
                                <i class='bx bxs-star i-color'></i>
                            </li>
                        </ul>
                    </div>

                    <div class="status-tag bg-color-green">
                        <a routerLink="/listing-details"><h3>Disponible Ahora</h3></a>
                    </div>

                    <div class="content">
                        <div class="content-profile">
                            <img src="assets/img/place-area/place-area-profile.png" alt="Images">
                            <h3>Por, Juan Pérez</h3>
                        </div>
                        <span><i class="flaticon-cursor"></i> Calle Luna 123, Madrid, España</span>
                        <a routerLink="/listing-details"><h3>Consultoría Fiscal </h3></a>
                        <p>Ofrecemos asesoramiento fiscal y contable para pymes y autónomos. Expertos en el sector con más de 10 años de experiencia.</p>
                        <div class="content-tag">
                            <ul>
                                <li><a routerLink="/"><i class="flaticon-place"></i></a></li>
                                <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                                <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                            </ul>
                            <h3 class="price"> <a href="#">200€-500€</a></h3>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>

<!-- <div class="application-area pt-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5">
                <div class="application-img">
                    <img src="assets/img/mobile.png" alt="Images">
                </div>
            </div>

            <div class="col-lg-7">
                <div class="application-content">
                    <div class="section-title">
                        <span>Download app</span>
                        <h2>Get More In Our Application Sit Back And Enjoy</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. </p>
                    </div>

                    <div class="application-btn">
                        <a href="#" class="application-play-btn">
                            <img src="assets/img/google-play.svg" alt="svg">
                            <div class="btn-content">
                                <span>ANDROID APP ON</span>
                                <h3>Google Play</h3>
                            </div>
                        </a>
                        <a href="#" class="application-play-btn">
                            <img src="assets/img/company.svg" alt="svg">
                            <div class="btn-content">
                                <span>DOWNLOAD ON THE</span>
                                <h3>App Store</h3>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->


<div class="application-area pt-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5">
                <div class="application-img">
                    <!-- Asegúrate de cambiar la imagen a una más relevante, por ejemplo, una captura de pantalla de la aplicación AccioGest. -->
                    <img src="assets/img/mobile.png" alt="Imagen de la aplicación AccioGest">
                </div>
            </div>

            <div class="col-lg-7">
                <div class="application-content">
                    <div class="section-title">
                        <span>Descarga la app</span>
                        <h2>Optimiza tus gestiones con AccioGest</h2>
                        <p>Descarga nuestra aplicación y lleva la gestión de tus proyectos y tareas a cualquier lugar. Una herramienta imprescindible para profesionales en movimiento.</p>
                    </div>

                    <div class="application-btn">
                        <a href="#" class="application-play-btn">
                            <!-- Asegúrate de cambiar la imagen a una del logo de Google Play. -->
                            <img src="assets/img/google-play.svg" alt="Google Play Logo">
                            <div class="btn-content">
                                <span>APLICACIÓN PARA</span>
                                <h3>Google Play</h3>
                            </div>
                        </a>
                        <a href="#" class="application-play-btn">
                            <!-- Asegúrate de cambiar la imagen a una del logo de la App Store. -->
                            <img src="assets/img/company.svg" alt="App Store Logo">
                            <div class="btn-content">
                                <span>DESCARGA EN</span>
                                <h3>App Store</h3>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- <section class="testimonial-area pb-70">
    <div class="container-fluid">
        <div class="section-title text-center">
            <span>Testimonials</span>
            <h2>What Our Clients Say</h2>
        </div>

        <div class="testimonial-slider owl-carousel owl-theme">
            <div class="testimonial-item testimonial-item-bg">
                <h3>Sanaik Tubi</h3>
                <span>Arbon Restaurant</span>
                <p>Roinin ipsum dolor sit amet, consectetur adipisicing  sit ut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <div class="testimonial-top">
                    <i class='bx bxs-quote-left'></i>
                </div>
            </div>

            <div class="testimonial-item testimonial-item-bg">
                <h3>Oli Rubion</h3>
                <span>Rubion Inc</span>
                <p>Roinin ipsum dolor sit amet, consectetur adipisicing  sit ut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <div class="testimonial-top">
                    <i class='bx bxs-quote-left'></i>
                </div>
            </div>

            <div class="testimonial-item testimonial-item-bg">
                <h3>Mashrof Ruin</h3>
                <span>Pice Cafe</span>
                <p>Roinin ipsum dolor sit amet, consectetur adipisicing  sit ut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <div class="testimonial-top">
                    <i class='bx bxs-quote-left'></i>
                </div>
            </div>

            <div class="testimonial-item testimonial-item-bg">
                <h3>Sanaik Tubi</h3>
                <span>Arbon Restaurant</span>
                <p>Roinin ipsum dolor sit amet, consectetur adipisicing  sit ut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <div class="testimonial-top">
                    <i class='bx bxs-quote-left'></i>
                </div>
            </div>

            <div class="testimonial-item testimonial-item-bg">
                <h3>Sanaik Tubi</h3>
                <span>Arbon Restaurant</span>
                <p>Roinin ipsum dolor sit amet, consectetur adipisicing  sit ut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <div class="testimonial-top">
                    <i class='bx bxs-quote-left'></i>
                </div>
            </div>
        </div>
    </div>
</section> -->


<section class="testimonial-area pb-70">
    <div class="container-fluid">
        <div class="section-title text-center">
            <span>Testimonios</span>
            <h2>Lo que dicen nuestros clientes</h2>
        </div>

        <div class="testimonial-slider owl-carousel owl-theme">
            <!-- Nota: Deberías sustituir los nombres, empresas y comentarios con testimonios reales de tus clientes. -->
            <div class="testimonial-item testimonial-item-bg">
                <h3>Juan Martínez</h3>
                <span>Empresa ABC</span>
                <p>Con AccioGest, hemos mejorado la gestión de nuestros proyectos. El equipo de soporte siempre está dispuesto a ayudar.</p>
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <div class="testimonial-top">
                    <i class='bx bxs-quote-left'></i>
                </div>
            </div>

            <!-- Puedes añadir más testimonios como el anterior. Aquí solo te doy un ejemplo. -->
            <div class="testimonial-item testimonial-item-bg">
                <h3>Maria González</h3>
                <span>Soluciones XY</span>
                <p>Desde que utilizamos AccioGest, nuestra eficiencia ha aumentado. Recomiendo esta herramienta a otras empresas.</p>
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <div class="testimonial-top">
                    <i class='bx bxs-quote-left'></i>
                </div>
            </div>

            <!-- Y así sucesivamente para cada testimonio... -->
        </div>
    </div>
</section>



<app-footer-style-one></app-footer-style-one>
